// directives
import Vue from "vue";
import {eventListener_addEventListenerToObj, eventListener_removeEventListenerToObj} from "./scripts/S_EventListeners";
import {enum_eventsListenersNames} from "../functions/src/shareCode/Share_S_Enum";
import {store_var, store_setStateValue} from "./store";

Vue.directive('tqdblclick', {
    // When the bound element is inserted into the DOM...
    inserted: function (el, binding) {
        let clicks = 0
        el.addEventListener('click', ()=>{

            clicks++
            if(clicks > 1){
                clicks = 0
                binding.value()
            }else{
                setTimeout(function() {
                    clicks = 0
                }, 700)
            }
        })
    },
    unbind: (el, binding) => {

        // remove listener from body
        document.getElementsByTagName("BODY")[0].removeEventListener("click", el.clickOutSideFunc)
    }
})

Vue.directive('click-out-side', {
    // When the bound element is inserted into the DOM...

    inserted: (el, binding) => {

        setTimeout(() =>{

            // 1) click inside element
            eventListener_addEventListenerToObj(el , enum_eventsListenersNames.click, false, getUniqueId_f(el), () => {
                el.clickElement = true
            })

            // 2) click outside element
            let body = document.getElementsByTagName("BODY")[0]
            eventListener_addEventListenerToObj(body , enum_eventsListenersNames.click, false, getUniqueId_f(el), () => {
                if (!el.clickElement) {
                    binding.value()
                }

                el.clickElement = false
            })

        }, 100);

    },
    unbind: (el, binding) => {

        setTimeout(() =>{

            eventListener_removeEventListenerToObj(el, enum_eventsListenersNames.click, getUniqueId_f(el))

            let body = document.getElementsByTagName("BODY")[0]
            eventListener_removeEventListenerToObj(body, enum_eventsListenersNames.click, getUniqueId_f(el))
        }, 100);


    }
})

Vue.directive('tq-focusable', {

    inserted: (el, binding) => {
        eventListener_addEventListenerToObj(el , enum_eventsListenersNames.focus, false, "tq-focusable-directive", () =>{
            store_setStateValue(store_var.system_inputFocus_b, true, false)
        })
        eventListener_addEventListenerToObj(el , enum_eventsListenersNames.blur, false, "tq-focusable-directive", () =>{
            store_setStateValue(store_var.system_inputFocus_b, false, false)
        })
    },
    unbind: (el, binding) => {
        eventListener_removeEventListenerToObj(el, enum_eventsListenersNames.focus, "tq-focusable-directive")
        eventListener_removeEventListenerToObj(el, enum_eventsListenersNames.blur, "tq-focusable-directive")
    }

});


Vue.directive('tq-touchstart', {

    inserted: (el, binding) => {
        eventListener_addEventListenerToObj(el , enum_eventsListenersNames.touchstart,
            false, getUniqueId_f(el), binding.value)
    },
    unbind: (el, binding) => {
        eventListener_removeEventListenerToObj(el, enum_eventsListenersNames.touchstart, getUniqueId_f(el))
    }

});

Vue.directive('tq-touchcancel', {

    inserted: (el, binding) => {
        eventListener_addEventListenerToObj(el , enum_eventsListenersNames.touchcancel,
            false, getUniqueId_f(el), binding.value)
    },
    unbind: (el, binding) => {
        eventListener_removeEventListenerToObj(el, enum_eventsListenersNames.touchcancel, getUniqueId_f(el))
    }

});

Vue.directive('tq-touchend', {

    inserted: (el, binding) => {
        eventListener_addEventListenerToObj(el , enum_eventsListenersNames.touchend,
            false, getUniqueId_f(el), binding.value)
    },
    unbind: (el, binding) => {
        eventListener_removeEventListenerToObj(el, enum_eventsListenersNames.touchend, getUniqueId_f(el))
    }

});


let idCounter = new Date().getTime();
const getUniqueId_f = ( node ) => {
    return node.id ? node.id : (node.id = 'tempIdPrefix_' + idCounter++)
}



